import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Button, Divider, Row, Spin, Table, message } from 'antd';
import ErrorWrapper from '../../../lib/error_wrapper';
import moment from "moment";
import { formatMoney } from '../../../lib/util';
import { PopUpForm } from '../../../lib/ui/popupform';


class RefillATMADetail extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       edit_data:{},
       edit_id:this.props.edit_id,
       loaded:false,
       isUploadingImage:false,
    };

    this.uploadImageExecutor=RESTExecutor.patch().config({
      label:'atm_refill_image_update'
    }).forId(this.props.edit_id).callbacks((success)=>{
      this.setState({isUploadingImage:false,loaded:false});
      this.get_detail.execute();
    }).connect(props.domains.activity);

    this.get_detail=RESTExecutor.detail().config({
      label:'atm_refill_detail',
  }).forId(this.props.edit_id).callbacks((success)=>{
    let d=success.result??{};
    d={
      ...d,
      ...d?.deno_details
    }
      this.setState({
          edit_data:d,
          loaded:true
      })
  },(error)=>{
    this.setState({
        loaded:true
    })
  }).connect(props.domains.activity);


    if(this.props.edit_id){
   this.get_detail.execute()
  }   
  };
  
render() {
    const {loaded,edit_data,edit_id}=this.state;
    if(!loaded){
        return <center><Spin/></center>
    }

  const uploadImageExecutorResponse=this.uploadImageExecutor.response();

  return (
    <div> 
        <ErrorWrapper no_back_action error={this.get_detail.response()} onReload={()=>{
            this.setState({loaded:false});
            this.get_detail.execute();
        }}>
          <PopUpForm
          title={`Upload Image`}
          stringyfy={false}
          show_title_only
          forCreate={true}
          initialData={{}}
          fields={[
            { index: "image", name: "File", type: "file", accept:'.jpg,.png,.jpeg' },
          ]}
          open={this.state.isUploadingImage}
          networkState={uploadImageExecutorResponse}
          onClose={() =>{
            this.setState({
              isUploadingImage:false
            })
          }
          }
          onSubmit={(data) => {
            console.log("DATA", data);
            if (!data.image) {
              message.warn("Cannot upload empty data...");
              return;
            } else {
              let _formdata = new FormData();
              Object.keys(data).map((key) => {
                _formdata.append(key, data[key]);
              });
              // message.warn("END POINT NOT MADE")
              this.uploadImageExecutor
                .execute(_formdata);
            }
            // this.handlePostPatch(data);
          }}
        />
           <div  style={{
        display: 'flex',
        flexDirection: 'column',
        gap:'16px'
      }}>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap:'16px'
        }}>
          <Row type='flex' justify='center' style={{
            flex: 1,
            gap:'16px'
          }}>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:'4px'}}>
              <span>Refill Date</span>
              <div>{moment(edit_data.refill_date).format("ddd, DD MMM YYYY")}</div>
            </div>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:'4px'}}>
              <span>Branch Name</span>
              <div>{edit_data.branch}</div>
            </div>
            </Row>
            <Row type='flex' justify='center' style={{
            flex: 1,
            gap:'16px'
          }}>
           <div style={{flex:1,display:'flex',flexDirection:'column',gap:'4px'}}>
              <span>Terminal ID</span>
              <div>{edit_data.source_name}</div>
            </div>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:'4px'}}>
              <span>From CBS Host Balance (System Cash Balance)</span>
              <div>{formatMoney(edit_data.cbs_host_balance)}</div>
              </div>
            </Row>
            </div>
          <Divider style={{
            marginTop: 0,
            marginBottom: 0
          }} />
          <div style={{
            display:'flex',
            flexDirection:'column',
            gap:'8px'
          }}>
          <div className='table-head-title'>Bills from ATM Cash Cassettes</div>
          <Table
                        className='main-table editable-table'
                        size='small'
                        dataSource={edit_data.cash_cassettes??[]}
                        loading={false}
                        columns={[
                          {
                            title:"Denomination",
                            key:'deno',
                            dataIndex:'deno'
                          },
                          {
                            title:"Quantity",
                            key:'qty',
                            dataIndex:'qty',
                          },
                          {
                            title:"Amount",
                            key:'amt',
                            dataIndex:'amt'
                          },
                          {
                            title:"Cassette Type",
                            key:'cassette_type',
                            dataIndex:'cassette_type',
                          }
                        ]}
                        pagination={false}
                    />
          </div>
          <div className='col gap-16'>
          <div className='table-head-title'>Bills from ATM Divert Cassettes</div>
          <Table
                        className='main-table editable-table'
                        size='small'
                        dataSource={edit_data.divert_cassettes??[]}
                        loading={false}
                        columns={[
                          {
                            title:"Denomination",
                            key:'deno',
                            dataIndex:'deno'
                          },
                          {
                            title:"Quantity",
                            key:'qty',
                            dataIndex:'qty',
                          },
                          {
                            title:"Amount",
                            key:'amt',
                            dataIndex:'amt'
                          },
                          {
                            title:"Cassette Type",
                            key:'cassette_type',
                            dataIndex:'cassette_type',
                          }
                        ]}
                        pagination={false}
                    />
            <div style={{display:'flex',flexDirection:'row'}}>
              <div className='flex col gap-2'>
                <strong>Total Balance from ATM</strong>
                <div>{formatMoney(edit_data.atm_balance)}</div>
              </div>
              <div className='flex col gap-2'>
                <strong>Difference</strong>
                <div>{formatMoney(edit_data.difference)}</div>
              </div>
            </div>

            <div className='flex col gap-2'>
            <span>Remarks (Short / Excess / Reconciled)</span>
            <div>{edit_data.remarks}</div>
            </div>
          </div>
          <Divider style={{
            marginTop: 0,
            marginBottom: 0
          }} />
          <div className='col gap-16'>
          <div className='table-head-title'>New Added Cash Denominations</div>
          <Table
                        className='main-table editable-table'
                        size='small'
                        dataSource={edit_data.new_added??[]}
                        loading={false}
                        columns={[
                          {
                            title:"Denomination",
                            key:'deno',
                            dataIndex:'deno'
                          },
                          {
                            title:"Quantity",
                            key:'qty',
                            dataIndex:'qty',
                          },
                          {
                            title:"Amount",
                            key:'amt',
                            dataIndex:'amt'
                          },
                          {
                            title:"Cassette Type",
                            key:'cassette_type',
                            dataIndex:'cassette_type',
                          }
                        ]}
                        pagination={false}
                    />
          <div className='table-head-title'>Total Number of Bill Replenished (Previous + Added Denominations)</div>
          <Table
                        className='main-table editable-table'
                        size='small'
                        dataSource={edit_data.num_bills_replenished??[]}
                        loading={false}
                        columns={[
                          {
                            title:"Denomination",
                            key:'deno',
                            dataIndex:'deno'
                          },
                          {
                            title:"Quantity",
                            key:'qty',
                            dataIndex:'qty',
                          },
                          {
                            title:"Amount",
                            key:'amt',
                            dataIndex:'amt'
                          },
                        ]}
                        pagination={false}
                    />
           <div className='flex col gap-2'>
                <strong>Total Bills Replenished</strong>
                <div>{formatMoney(edit_data.total_bills_replenished)}</div>
            </div>
          </div>
          <Divider style={{
            marginTop: 0,
            marginBottom: 0
          }} />
          <div className='col gap-16'>
          <div className='row gap-16 align-center'>
          {edit_data.image&&
          <div style={{display:'flex',flexDirection:'row'}}>
            <a href={edit_data.image} target='_blank'>
            <img style={{
              maxHeight:'200px',
              maxWidth:'100%',
              objectFit:'contain'
            }} src={edit_data.image}/>
            </a>
          </div>
          }
          <Button type='primary'  onClick={()=>{
            this.setState({
              isUploadingImage:true
            })
          }} >{edit_data.image?"Update Image":"Add Image"}</Button>
          </div>
          <div style={{display:'flex',flexDirection:'row'}}>
          <div className='flex col gap-2'>
                <strong>Request Date</strong>
                <div>{moment(edit_data.request_date).format("ddd, DD MMM YYYY")}</div>
            </div>
            <div className='flex col gap-2'>
                <strong>Entered By</strong>
                <div>{edit_data.entered_by_name}</div>
            </div>
          </div>
          </div>
        </div>
        </ErrorWrapper>
      </div>
  );
}

componentDidUpdate = (prevProps) => {
  if ( this.props.edit_id !== prevProps.edit_id && null!=this.props.edit_id) {

      this.setState({
          edit_id: this.props.edit_id,
          loaded:false
      })
      this.get_detail.forId(this.props.edit_id).execute();
  };
}
}
export default withDomains(RefillATMADetail,'activity');
